import { ApiError } from '@/api/http';

/**
 * Is this error the API saying "I do not know who you are"?
 *
 * Only 401 and 403 are. Everything else — a dropped connection, a 500, the
 * 503 the server sends while the database is unreachable — says nothing
 * about the session, and treating it as a rejection is how an operator gets
 * signed out by a backend restart or by walking into a lift.
 *
 * Its own module rather than a local helper in App.tsx so it can be tested
 * directly: this one predicate decides whether somebody stays signed in, and
 * it is a pure function of the error, which is exactly the shape worth
 * pinning.
 */
export const isAuthRejection = (error: unknown): boolean =>
  error instanceof ApiError && (error.status === 401 || error.status === 403);
